<div class="t-popup popup-patientDetails" [formGroup]="allDayEventForm">
  <div class="t-popup-close"></div>
  <div class="t-popup-frame" style="display: flex; flex-direction:column;" cdkDrag cdkDragBoundary=".t-popup">
    <div class="t-popup-body">
      <button class="t-btn-popup-close" aria-label="close popup" (click)="closeEventModal()"></button>
      <h2 style="cursor: grab;" cdkDragHandle>
        {{'appointments.gui.labels.Set event details' | translate}}
      </h2>
      <ng-container *ngIf="!event">
        <td *ngIf="!ls?.premissions?.ApptsByRoom"><mat-form-field>
            <mat-label [ngClass]="['mat-select-value']">
              {{'appointments.gui.labels.Doctors' | translate}}
            </mat-label>
            <mat-select multiple formControlName="UID" [ngClass]="['mat-select-value','mat-form-field']">
              <ng-container *ngFor="let e of this.ls.clinicUsers">
                <mat-option [value]="e.UID.toString()" [ngClass]="['mat-select-value']">{{ e.Name }}</mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field></td>
        <td *ngIf="ls?.premissions?.ApptsByRoom"><mat-form-field>
            <mat-label [ngClass]="['mat-select-value']">
              {{'appointments.gui.label.rooms' | translate}}
            </mat-label>
            <mat-select multiple formControlName="RID" [ngClass]="['mat-select-value','mat-form-field']">
              <ng-container *ngFor="let e of this.ls.activeRooms">
                <mat-option [value]="e.AutoIndex.toString()" [ngClass]="['mat-select-value']">{{ ls.roomLabel(e)
                  }}</mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field></td>
      </ng-container>

      <div style="display: grid; grid-auto-flow: column; margin-bottom: 1em;">
        <div class="l-flex l-flex-w t-fieldmargin patient-details">
          <div class="w50">
            <div class="l-flex l-flex-c t-field t-field-pad" style="min-width: 17em;">
              <label class="nowrap">
                {{'appointments.gui.labels.Start date' | translate}}
              </label>
              <i class="t-sep"></i>
              <input [matDatepicker]="startEventDate" formControlName="eventStartDate" class="t-field-text w100" />
              <img src="../../assets/icons/date.svg" (click)="startEventDate.open()" style='margin-left: -1.8em;'>
              <mat-datepicker #startEventDate startView="year"></mat-datepicker>
            </div>
          </div>
        </div>

        <div class="l-flex l-flex-w t-fieldmargin patient-details">
          <div class="w50">
            <div class="l-flex l-flex-c t-field t-field-pad" style="min-width: 17em;">
              <label class="nowrap">
                {{'appointments.gui.labels.End date' | translate}}
              </label>
              <i class="t-sep"></i>
              <input [matDatepicker]="endEventDate" formControlName="eventEndDate" class="t-field-text w100" />
              <img src="../../assets/icons/date.svg" (click)="endEventDate.open()" style='margin-left: -1.8em;'>
              <mat-datepicker #endEventDate startView="year"></mat-datepicker>
            </div>
          </div>
        </div>

        <div class="l-flex l-flex-w t-fieldmargin patient-details">
          <div style="width: min-content">
            <div class="l-flex l-flex-c t-field t-field-pad nowrap">
              <label class="nowrap">
                {{'appointments.gui.labels.Duration' | translate}}
              </label>
              <i class="t-sep"></i>
              <input type="text" class="t-field-text w100" formControlName="duration" />
              <span style="margin-right: 5%;" *ngIf="formattedDuration.days > 0">
                {{ formattedDuration.days }} ימים
              </span>
            </div>
          </div>
        </div>
      </div>



      <div class="l-flex l-flex-w t-fieldmargin patient-details">
        <div class="w100">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label>
              {{'appointments.gui.labels.Comments' | translate}}
            </label>
            <textarea class="t-field-text w100" formControlName="comment"></textarea>
          </div>
        </div>
      </div>


      <div *ngIf="!event" style="display: flex; flex-direction: row;justify-content: space-between; margin-top: 1em;">
        <button class="btn-cancel" matTooltip="{{'appointments.gui.tooltips.Cancel' | translate}}"
          (click)="closeEventModal()">
          {{'appointments.gui.buttons.Cancel' | translate}}
        </button>
        <button class="btn-ok" matTooltip="{{'appointments.gui.tooltips.Save All Day Event' | translate}}"
          (click)="saveEvent()">
          {{'appointments.gui.buttons.Save' | translate}}
        </button>
      </div>
      <div *ngIf="event" style="display: flex; flex-direction: row;justify-content: space-between; margin-top: 1em;">
        <button class="btn-cancel" matTooltip="{{'appointments.gui.tooltips.Delete All Day Event' | translate}}"
          (click)="showDeleteAlert=true">
          {{'appointments.gui.buttons.Delete' | translate}}
        </button>

        <div *ngIf="showDeleteAlert" class="t-validation-wrap">
          <button class="t-menu-item is-invalid-left"></button>
          <div class="t-validation-message-left" style="width: 20em; left: -11em; top: -1.5em; font-size: medium;">
            <span style="border-radius: 8px">
              <p style="margin-bottom: 1em;">
                {{'appointments.gui.labels.Delete Event' | translate}}
              </p>
              <div style="display: flex; justify-content: space-between; margin-left: 1vw; margin-right: 1vw;">
                <button class="t-menu-item" (click)="deleteEvent()">
                  {{'appointments.gui.buttons.Yes' | translate}}
                </button>
                <button class="t-menu-item" (click)="showDeleteAlert = false">
                  {{'appointments.gui.buttons.No' | translate}}
                </button>
              </div>
            </span>
          </div>
        </div>
        <button class="btn-ok" matTooltip="{{'appointments.gui.tooltips.Update All Day Event' | translate}}"
          (click)="updateEvent()">
          {{'appointments.gui.buttons.Close & Update' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>